<template>
  <!-- 延期审批历史记录 -->
  <div class="record-list">
    <a-card style="margin-bottom: 10px">
      <search-view
        :renderItem="SEARCH_SCHEMA"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button @click="exportTable" type="primary">导出</a-button>
      </div>
      <table-view
        bordered
        :data="tableData"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="SCROLL"
        @handlePagination="handlePagination"
      >
        <template v-slot:applyAmount="{ tableRow }">
          <span v-html="$formatAppAmount(tableRow.applyAmount)"></span>
        </template>

        <template v-slot:approveAmount="{ tableRow }">
          <span v-html="$formatAppAmount(tableRow.approveAmount)"></span>
        </template>

        <template v-slot:type="{ tableRow }">
          <span>{{ CREDIT_TYPE_OBJ[tableRow.type] }}</span>
        </template>

        <template v-slot:status="{ tableRow }">
          <a-tag
            :color="APPROVE_STATUS_OBJ[tableRow.status].color"
            style="width: 70px; text-align: center;"
          >
            {{ APPROVE_STATUS_OBJ[tableRow.status].label }}
          </a-tag>
        </template>

        <template v-slot:action="{ tableRow }">
          <a-button type="link" size="small" @click="handleView(tableRow)">
            查看
          </a-button>
        </template>
      </table-view>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import cloneDeep from 'lodash/cloneDeep'
import { SEARCH_SCHEMA } from './schema'
import { APPROVE_STATUS_COLOR_OBJ, MY_APPROVE_STATUS_OBJ, CREDIT_TYPE_OBJ, APPROVE_STATUS_OBJ } from './const'
import { getExtensionRecordList, extensionExportList, getCreditManagers  } from './api'
import { formatParamDate } from 'utils/util'

export default {
  name: 'extension-record-search',
  data() {
    const initSearchForm = {
      companyName: '',
      companyCode: '',
      endTime: '',
      startTime: '',
      id: '',
      creditManager: '',
    }
    const searchForm = cloneDeep(initSearchForm)
    return {
      SEARCH_SCHEMA,
      APPROVE_STATUS_COLOR_OBJ,
      MY_APPROVE_STATUS_OBJ,
      CREDIT_TYPE_OBJ,
      APPROVE_STATUS_OBJ,
      initSearchForm,
      searchForm,
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableLoading: false,
      tableData: [],
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
          width: 80,
          align: 'center',
          fixed: 'left',
        },
        {
          title: '流水号',
          dataIndex: 'id',
          align: 'center',
          width: 150,
        },
        {
          title: '申请人',
          dataIndex: 'applier',
          width: 150,
        },
        {
          title: '申请日期',
          dataIndex: 'applyDate',
          align: 'center',
          width: 170,
        },
        {
          title: '企业名称',
          dataIndex: 'companyName',
          width: 300,
        },
        {
          title: '企业ID',
          dataIndex: 'companyCode',
          width: 150,
        },
        {
          title: '原到期日',
          dataIndex: 'oldIndateEnd',
          align: 'center',
          width: 130,
        },
        {
          title: '申请延期至',
          dataIndex: 'newIndateEnd',
          align: 'center',
          width: 130,
        },
        {
          title: '信用类型',
          scopedSlots: { customRender: 'type' },
          align: 'center',
          width: 150,
        },
        {
          title: '信用主管',
          dataIndex: 'creditManager',
          width: 100,
        },
        {
          title: '当前审批人',
          dataIndex: 'approveRole',
          width: 120,
        },
        {
          title: '状态',
          scopedSlots: { customRender: 'status' },
          width: 100,
        },
        {
          title: '审批日期',
          dataIndex: 'approveDate',
          align: 'center',
          width: 200
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 100,
          fixed: 'right',
        },
      ],
      SCROLL: { x: 2300 },
    }
  },
  mounted() {
    this._getExtensionRecordList(this.initSearchForm)
    this._getCreditManagers()
  },
  methods: {
    async _getExtensionRecordList(searchForm) {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...searchForm,
        size: pageSize,
        current,
      }
      console.log(formData);
      try {
        const {
          data: { total, records },
        } = await getExtensionRecordList(formData)
        this.pageData.total = total
        this.tableData = records.map(item => {
          item.key = `${item.id}_${item.approveDate}`
          return item
        })
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    handleSearch(data) {
      data = formatParamDate(data, data.applyRangeDate)
      delete data.applyRangeDate
      delete data.approveRangeDate
      this.searchForm = data
      this.pageData.current = 1 // 设置为第一页
      this._getExtensionRecordList(data)
    },
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getExtensionRecordList(this.searchForm)
    },
    async _getCreditManagers() {
      try {
        const { data } = await getCreditManagers()
        const list = data.map(item => {
          return {
            text: item.name + '-' + item.username,
            value: item.username,
          }
        })
        this.SEARCH_SCHEMA[4].selectList = [{ text: '全部', value: '' }].concat(
          list,
        )
      } catch (error) {
        console.error(error)
      }
    },
    handleView(row) {
      const { id, type, status } = row
      this.$router.push({
        path: `/credit-approval/limit/apply-detail/${id}`,
        query: {
          type,
          status,
        },
      })
    },
    exportTable() {
      const params = {
        ...this.searchForm,
      }
      extensionExportList(params)
    },
  },
  components: {
    SearchView,
    TableView,
  },
}
</script>

<style></style>
